import { Button, FormControl, NativeBaseProvider, TextField, View, Text } from "native-base";
import { useState } from "react";
import { newImportedPlayer } from "./classes/Player";
import { addImportedPlayer } from "./functions/players";


export default function BulkAddPlayer() {

    let [csvValue, setCSVValue] = useState("")
    let [playerListID, setPlayerListID] = useState("")

    async function onSubmit() {

        console.log(csvValue)
        let splitCSV = csvValue.split("\n")
        console.log(splitCSV)
        let playerList = splitCSV.map((player)=>{
            let playerSplit = player.split(",")
            return newImportedPlayer(playerSplit[0], playerSplit[1], "",playerSplit[2])
        })
        console.log(playerList)
            playerList.forEach(async (newPlayer)=>{
            let playerID = await addImportedPlayer(playerListID, newPlayer);
            })
              


        //         let newPlayer = newImportedPlayer(firstName, lastName, imageURL, country);
        // let playerID = await addImportedPlayer(props.route.params.playerListID, newPlayer);
    }

    return (
        <NativeBaseProvider>

            <View>
                <FormControl>
                    <FormControl.Label>Player List ID</FormControl.Label>
                    <TextField onChangeText={(text) => {
                        setPlayerListID(text)
                    }} ></TextField>
                    <FormControl.Label>FirstName, LastName, Country Code</FormControl.Label>
                    <TextField multiline placeholder="CSV Values" onChangeText={(text) => {
                        setCSVValue(text)
                    }}></TextField>
                </FormControl>

                <Button onPress={()=>{onSubmit()}}>
                    <Text>Submit</Text>
                </Button>



            </View>
        </NativeBaseProvider>

    )
}

